"use client";

import { getSlug, imageFallback } from "@shared/utils";
import { Card, CardContent, CardFooter, CardHeader } from "@ubud-ui/react-ui-kit";
import Image from "next/image";
import Link from "next/link";
import { Government } from "../types";

type GovernmentCardProps = {
  government: Government;
  onClick?: (government: Government) => void;
};
export function GovernmentCard({ government, onClick }: GovernmentCardProps) {
  const handleClick = () => {
    if (onClick) {
      onClick(government);
    }
  };
  return (
    <>
      <Card className="w-full h-full bg-white border border-gray-200 rounded-xl flex flex-col justify-between relative overflow-hidden shadow-none">
        <div>
          <CardHeader className="p-4 flex items-start justify-between flex-row">
            <Image
              src={government.logoUri || "/blank-white.webp"}
              alt={government.name}
              width="60"
              height="60"
              className="size-14 xl:size-[60px] bg-white border border-grey-200 rounded-lg object-contain"
              onError={imageFallback()}
            />
          </CardHeader>
          <CardContent className="pt-4 px-4 pb-0">
            <div className="max-h-24 overflow-hidden flex flex-col gap-0.5">
              <h4 className="font-bold text-base overflow-hidden max-h-[48px]">
                <Link
                  href={`/instansi-pemerintah/${getSlug(government.id, government.name)}`}
                  onClick={handleClick}
                  className="hover:text-primary"
                >
                  {government.name}
                </Link>
              </h4>
            </div>
          </CardContent>
        </div>
        <CardFooter className="px-4 pb-4 block">
          <p className="text-xs font-normal text-gray-500 truncate mt-1">{government.cityName || "-"}</p>
        </CardFooter>
      </Card>
    </>
  );
}
